export const SINGLE_GROUP_FIELD_GQL_TYPE = 'JiraSingleGroupPickerField';
export const MULTIPLE_GROUP_FIELD_GQL_TYPE = 'JiraMultipleGroupPickerField';
